import { Asset as IAsset } from 'contentful'
import { ensureAbsoluteUrl } from 'services/ContentfulService/utils'
import { isBrowser } from 'lib'
import Logger from 'services/Logger'

type ImageMimes = 'image/svg+xml' | 'image/avif' | 'image/jpg' | 'image/jpeg' | 'image/png' | string

export interface Asset {
	id: string
	title?: string
	fit?: 'fill' | 'fit'
	description?: string
	url: string
	contentType: ImageMimes
	aspectRatio?: number
	placeholderDataURL?: string
}

export const parseAsset = (rawAsset: IAsset): Asset => {
	const image = rawAsset.fields.file.details.image
	const ratio = image ? image.width / image.height : undefined
	const url = rawAsset.fields.file.url
	const contentType = rawAsset.fields.file.contentType
	return {
		title: rawAsset.fields.title,
		contentType,
		id: rawAsset.sys.id,
		url: `${ensureAbsoluteUrl(url)}`,
		description: rawAsset.fields.description,
		aspectRatio: ratio
	}
}

export const enhanceAsset = async (asset: Asset): Promise<Asset> => {
	if (isBrowser()) return asset
	if (asset.contentType.includes('svg')) return asset
	try {
		const placeholderUrl = `${asset.url}?w=${30}&q=${20}&fm=jpg`
		const response = await fetch(placeholderUrl)
		const contentType = response.headers.get('Content-Type') || 'image/jpg'
		// @ts-ignore
		const body = await response.buffer().then(buffer => buffer.toString('base64'))
		const placeholder = `data:${contentType};base64,${body}`
		return { ...asset, placeholderDataURL: placeholder }
	} catch (err) {
		Logger.error(err)
		return asset
	}
}
